import Vue from 'vue';
import Connect from './graphql/Connect.vue';

Vue.component('amplify-connect', Connect);

export {
    Connect
};